<template>
  <div v-if="googleMapUrl">
    <div class="partnershop-location-headline" id="tome">
      <h2>{{ vueMapTextStrings.mapHeadline }}</h2>
    </div>
    <div class="wrapper-partnershop-map-iframe">
      <div class="gmap">
        <p align="center">
          <iframe style="border: 0;"
                  v-bind:src="googleMapUrl"
                  frameborder="0"></iframe>
        </p>
      </div>
    </div>
    <div class="partnershop-image-maps ps-image" v-bind:style="{ backgroundImage: `url(${partnerShopInformation.image})`, backgroundPosition: 'center center', backgroundSize: '60px' }"></div>
    <div class="partnershop-map-details">
      {{ displayFullName }}<br />
      {{ formatAddress }}<br />
      <div>
        <a v-bind:href="`tel:${this.partnerShopInformation.phone.number}`">
          {{ partnerShopInformation.phone.number }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config';
  import FetchHelper from '../../helpers/FetchHelper';
  import PartnerShopMethods from "../../services/PartnerShopMethods";

  export default {
    data: function() {
      return {
        googleMapApiKey: '&key=AIzaSyA6B67oc6yiFLU20jw2yuSB5sMCVVZrJGU',
        googleMapUrl: null,
        partnerShopInformation: {
          address: {
            city: null,
            country: null,
            latitude: null,
            longitude: null,
            postalCode: null,
            street: null,
            streetNumber: null,
          },
          company: null,
          email: null,
          firstname: null,
          image: null,
          lastname: null,
          long_description: null,
          phone: {
            mobile: {
              code: null,
              country: null,
              number: null,
              type: null,
            },
            telephone: {
              code: null,
              country: null,
              number: null,
              type: null,
            },
          },
          short_description: null,
        },
        partnerShopName: location.hostname.split(`.`)[0],
        vueMapTextStrings: window.vueMapTextStrings,
      };
    },
    computed: {
      displayFullName: function() {
        if(this.partnerShopInformation.firstname && this.partnerShopInformation.lastname) { return `${this.partnerShopInformation.firstname} ${this.partnerShopInformation.lastname}`; }
        if(this.partnerShopInformation.company) { return this.partnerShopInformation.company; }
      },
      formatAddress: function() {
        let address = ``;
        if(this.partnerShopInformation.address.street) address += this.partnerShopInformation.address.street;
        if(this.partnerShopInformation.address.streetNumber) address += ` ${this.partnerShopInformation.address.streetNumber}`;
        if(this.partnerShopInformation.address.street || this.partnerShopInformation.address.streetNumber) address += `, `;
        if(this.partnerShopInformation.address.postalCode) address += this.partnerShopInformation.address.postalCode;
        if(this.partnerShopInformation.address.city) address += ` ${this.partnerShopInformation.address.city}`;
        if(this.partnerShopInformation.address.postalCode || this.partnerShopInformation.address.city) address += `, `;
        if(this.partnerShopInformation.address.country) address += this.partnerShopInformation.address.country;
        return address;
      },
    },
    methods: {
      fetchAddressInformation: async function() {
        this.partnerShopInformation= await PartnerShopMethods.getPartnerShopInformation();

        if(this.partnerShopInformation) {
          if(this.partnerShopInformation.address.latitude && this.partnerShopInformation.address.longitude) {
            this.googleMapUrl = `https://www.google.com/maps/embed/v1/place?q=${this.partnerShopInformation.address.latitude},${this.partnerShopInformation.address.longitude}${this.googleMapApiKey}`
          } else {
            const address = this.partnerShopInformation.address;
            const mapParams = [];
            if(address.country) mapParams.push(encodeURIComponent(address.country));
            if(address.postalCode && address.city) mapParams.push(`${encodeURIComponent(address.postalCode)}+${encodeURIComponent(address.city)}`);
            else if(address.postalCode) mapParams.push(encodeURIComponent(address.postalCode));
            else if(address.city) mapParams.push(encodeURIComponent(address.city));
            if(address.street && address.streetNumber) mapParams.push(`${encodeURIComponent(address.street)}+${encodeURIComponent(address.streetNumber)}`);
            else if(address.street) mapParams.push(encodeURIComponent(address.street));
            else if(address.streetNumber) mapParams.push(encodeURIComponent(address.streetNumber));

            const mapParamsString = mapParams.length ? mapParams.join(`,`) : null;
            // postalCode+city,street+streetnumber,country
            if(mapParamsString) this.googleMapUrl = `https://www.google.com/maps/embed/v1/place?q=${mapParamsString}${this.googleMapApiKey}`;
          }
        }
      },
    },
    mounted: function() {
      this.fetchAddressInformation();
      window.$swal = this.$swal;
    },
  }
</script>
